export default __webpack_public_path__ + "static/media/pictogramBeaconPerson128.23cada15.svg";